import { request } from "@util/request"
import {
  api_v1_band_band_custom_mailer_templates_path,
  api_v1_band_band_custom_mailer_template_path,
} from "../routes"
import { MailerType } from "@models/bands"

function authHeaders(contentType = true): Record<string, string> {
  const token = localStorage.getItem("jwt_token")
  const csrf =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)
      ?.content || ""
  const headers: Record<string, string> = { "X-CSRF-Token": csrf }
  if (contentType) headers["Content-Type"] = "application/json"
  if (token) headers["Authorization"] = `Bearer ${token}`
  return headers
}

export interface BandCustomMailerTemplateParams {
  mailer_type?: MailerType
  name?: string
  content?: string
}

export async function getBandCustomMailerTemplates(
  bandId: number | string,
  mailerType?: MailerType,
) {
  return request({
    queryKey: [
      "band_custom_mailer_templates",
      {
        path: api_v1_band_band_custom_mailer_templates_path(bandId, {
          mailer_type: mailerType,
        }),
      },
    ],
  })
}

export async function createBandCustomMailerTemplate(
  bandId: number | string,
  params: BandCustomMailerTemplateParams,
) {
  const response = await fetch(
    api_v1_band_band_custom_mailer_templates_path(bandId),
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ band_custom_mailer_template: params }),
    },
  )
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || "Failed to create template")
  return data
}

export async function updateBandCustomMailerTemplate(
  bandId: number | string,
  templateId: number,
  params: BandCustomMailerTemplateParams,
) {
  const response = await fetch(
    api_v1_band_band_custom_mailer_template_path(bandId, templateId),
    {
      method: "PATCH",
      headers: authHeaders(),
      body: JSON.stringify({ band_custom_mailer_template: params }),
    },
  )
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || "Failed to update template")
  return data
}

export async function deleteBandCustomMailerTemplate(
  bandId: number | string,
  templateId: number,
) {
  const response = await fetch(
    api_v1_band_band_custom_mailer_template_path(bandId, templateId),
    {
      method: "DELETE",
      headers: authHeaders(false),
    },
  )
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || "Failed to delete template")
  return data
}
